// @flow
import React from 'react'
import i18n from 'live/services/i18n'
import styled from 'styled-components'
import { FontStyleButton, ConfigSubtitle } from 'plugin-assets/shared/widget/components/styled'

export default class PositionConfig extends React.Component<ConfigProps> {
    selectAlignLeft = () => this.props.changeLayoutConfig('align', 'left')
    selectAlignCenter = () => this.props.changeLayoutConfig('align', 'center')
    selectAlignRight = () => this.props.changeLayoutConfig('align', 'right')

    render() {
        const { config } = this.props

        return (
            <PositionConfigContainer>
                <div>
                    <ConfigSubtitle>{i18n('Position')}</ConfigSubtitle>
                    <div className="flex">
                        <FontStyleButton
                            onClick={this.selectAlignLeft}
                            isEditor={this.props.isEditor}
                            active={config.align === 'left'}
                        >
                            <i className="far fa-align-left" />
                        </FontStyleButton>
                        <FontStyleButton
                            onClick={this.selectAlignCenter}
                            isEditor={this.props.isEditor}
                            active={config.align === 'center'}
                        >
                            <i className="far fa-align-center" />
                        </FontStyleButton>
                        <FontStyleButton
                            onClick={this.selectAlignRight}
                            isEditor={this.props.isEditor}
                            active={config.align === 'right'}
                        >
                            <i className="far fa-align-right" />
                        </FontStyleButton>
                    </div>
                </div>
            </PositionConfigContainer>
        )
    }
}

const PositionConfigContainer = styled.div`
    padding: 0px 13px;
`
